module.exports = __webpack_public_path__ + "img/clock-four-thirty.282f487d.svg";